import { DateTime } from 'luxon';

export const ONE_DAY = 1;

export const DEFAULT_BUSINESS_DAYS = [1, 2, 3, 4, 5];

export interface Holiday {
  label: string;
  type?: 'single' | 'range';
  day?: number;
  month?: number;
  year?: number;
  start_date?: string; // YYYY-MM-DD format
  end_date?: string; // YYYY-MM-DD format
}

export function checkHoliday(holiday: Holiday, dateTime: DateTime) {
  // Handle range holidays
  if(holiday.type === 'range') {
    const startDate = DateTime.fromISO(holiday.start_date).startOf('day');
    const endDate = DateTime.fromISO(holiday.end_date).endOf('day');

    return dateTime >= startDate && dateTime <= endDate;
  }

  const matchesMonth = dateTime.month === holiday.month;
  const matchesDay = dateTime.day === holiday.day;
  const matchesYear = holiday.year ? dateTime.year === holiday.year : true;

  return matchesMonth && matchesDay && matchesYear;
}

export function isHoliday(dateTime: DateTime, holidays: Holiday[]) {
  const isDayAnyHoliday = holidays.some((holiday) => {
    return checkHoliday(holiday, dateTime);
  });

  return isDayAnyHoliday;
}

export function isBusinessDay(dateTime: DateTime) {
  const businessDays = DEFAULT_BUSINESS_DAYS;

  return businessDays.includes(dateTime.weekday);
}

export function plusBusinessDays(datetime: DateTime, holidays: Holiday[], days: number) {
  let dt = datetime;

  if(!dt.isValid) {
    return dt;
  }

  const isNegative = days < 0;

  let businessDaysLeftToAdd = isNegative ?
    Math.round(-1 * days) :
    Math.round(days);

  while(businessDaysLeftToAdd > 0) {
    const oneDayByDirection = isNegative ? -ONE_DAY : ONE_DAY;

    dt = dt.plus({ days: oneDayByDirection });

    if(isBusinessDay(dt) && !isHoliday(dt, holidays)) {
      businessDaysLeftToAdd--;
    }
  }

  return dt;
}

/**
 * Generate localized month names using Luxon
 * @param format - The format for month names ('short' for abbreviated, 'long' for full names)
 * @returns Array of month names
 */
export function getLocalizedMonths(format: 'short' | 'long' = 'short'): string[] {
  const months: string[] = [];

  for(let i = 1;i <= 12;i++) {
    const date = DateTime.fromObject({ month: i, day: 1 });
    const monthName = format === 'short' ? date.toFormat('MMM') : date.toFormat('MMMM');

    months.push(monthName);
  }

  return months;
}

// Default MONTHS array using localized month names
export const MONTHS = getLocalizedMonths();

// days in months
export const DAYS_IN_MONTH = [
  31,
  28,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31,
];

export const LEAP_YEAR_DAYS_IN_MONTH = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31,
];
